import React from 'react';
import PropTypes from 'prop-types';

import { ExpansionPanelSummary as MuiExpansionPanelSummary } from '@material-ui/core';

const ExpansionPanelSummary = ({ children, ...rest }) => {
  return (
    <MuiExpansionPanelSummary
      {...rest}
    >
      { children }
    </MuiExpansionPanelSummary>
  )
}

ExpansionPanelSummary.defaultProps = {
  children: null,
}

ExpansionPanelSummary.propTypes = {
  children: PropTypes.node,
};

export default ExpansionPanelSummary;



// WEBPACK FOOTER //
// ./src/components/base/ExpansionPanelSummary/ExpansionPanelSummary.js